import { ServiceFetch } from '../service-fetch'

export default class FactStockMoveModel extends ServiceFetch {
    getFactStockIssueBy = (data) => this.authFetch({
        url: 'fact-stock-issue/getFactStockIssueBy',
        method: 'POST',
        body: JSON.stringify(data),
    })
}